module.exports = __webpack_public_path__ + "static/df975d06.right.png";